import { isDevMode } from '../utils/helpers';

export const DevModeRibbon = () => {
  if (!isDevMode) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '18px',
        right: '-46px',
        zIndex: 9999,
        transform: 'rotate(45deg)',
        backgroundColor: '#c62828',
        color: '#fff',
        padding: '8px 56px',
        fontSize: '12px',
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.25)',
        pointerEvents: 'none',
      }}
    >
      Dev Mode
    </div>
  );
};
